<mat-card>
  <h2>{{ titleLabel }}</h2>
  <h3 *ngIf="documentType">Typ: {{ typeLabels[documentType] }}</h3>
  <mat-card-content>
    <p *ngIf="loading" class="loading">
      <mat-spinner diameter="32"></mat-spinner>
      Wird geladen…
    </p>
    <p *ngIf="error" class="error">{{ error }}</p>

    <div *ngIf="!loading && documentType != null" class="edit-form">
      <div class="actions">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
          {{ saving ? 'Speichern…' : (isNew? 'Anlegen' : 'Neue Version speichern') }}
        </button>
      </div>
      <mat-form-field *ngIf="isNew" appearance="outline" class="full-width">
        <mat-label>HTML-Inhalt</mat-label>
        <textarea matInput [(ngModel)]="htmlContent" rows="20" placeholder="HTML-Inhalt einfügen…"></textarea>
      </mat-form-field>
      <quill-editor
        *ngIf="!isNew"
        [(ngModel)]="htmlContent"
        format="html"
        [styles]="editorStyles"
        placeholder="Inhalt hier eingeben…"
        name="htmlContent"
      ></quill-editor>
    </div>
  </mat-card-content>
</mat-card>
